import React from 'react';
import { X } from "lucide-react"
import "./login-signup.css"

const ForgotPassword = ({
    closeAllModals,
    handleSendOtp,
    forgotEmail,
    setForgotEmail,
    forgotPasswordLoading
}) => {
    return (
        <>
         <div className="modal-overlay">
          <div className="modal-container">
            <div className="modal-header">
              <h3>Forgot Password</h3>
              <button className="modal-close" onClick={closeAllModals}>
                <X size={20} />
              </button>
            </div>
            <div className="modal-body">
              <p>Enter your email address to receive a verification code</p>
              <form onSubmit={handleSendOtp}>
                <div className="form-group">
                  <input
                    type="email"
                    placeholder="Email Address"
                    value={forgotEmail}
                    onChange={(e) => setForgotEmail(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" className="submit-button" disabled={forgotPasswordLoading}>
                  {forgotPasswordLoading ? (
                    <span className="loading-spinner">
                      <span className="spinner"></span>
                      Sending...
                    </span>
                  ) : (
                    "Send Verification Code"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
        </>
    )
}
export default ForgotPassword;